// Filas del plan que no se siguen y la oferta de DV360, dentro de la card de la línea (tanda «grupos,
// dinero y DV360», contrato §7 y §9.2). Una plataforma sin canal en Dashbo ya no bloquea la línea:
// su fila queda «no seguida», con su monto a la vista y restado del presupuesto (decisión B). Viajan
// en el payload del item: `untracked_rows` y `dv360_offer`. Sin esas claves no se dibuja nada.
// Módulo puro para testearlo sin montar la vista.

const REASON_KEYS = {NO_CHANNEL: 'reason_no_channel', NO_ACCOUNT_CHOSEN: 'reason_no_account'};
const DV360 = 'DV360';

const finite = (value) => value !== null && value !== undefined && value !== ''
    && Number.isFinite(Number(value));

// Las filas no seguidas del item, con su nombre y la clave del motivo (relativa a `media_plan.untracked`).
export function untrackedRowsOf(item) {
    const rows = (((item || {}).payload || {}).untracked_rows || []).filter(Boolean);
    return rows.map((row) => ({
        ...row,
        platform: row.label || row.platform_raw || row.platform || '',
        reasonKey: REASON_KEYS[row.reason] || null,
    }));
}

// El presupuesto que le queda a la línea si NO se suma la cuenta de la oferta (P-3 de `mp-be-reparto`,
// contrato §12 padre 5): lo trae el item de presupuesto de la MISMA línea en `amount_without_offer`. Se
// busca por `line_key` y no por id, porque los ids cambian en cada regeneración. null si no hay.
export function amountWithoutOfferFor(offerItem, items) {
    const lineKey = ((offerItem || {}).payload || {}).line_key;
    if (!lineKey) return null;
    const budget = (items || []).find((other) => other !== offerItem
        && ((other || {}).payload || {}).line_key === lineKey
        && finite(((other || {}).payload || {}).amount_without_offer));
    return budget ? Number(budget.payload.amount_without_offer) : null;
}

// La oferta de sumar la cuenta DV360 a la línea: qué plataforma del plan, cuánto y con qué cuenta.
// Si el backend no manda la plataforma o el monto, salen de las plataformas DV360 de los grupos del
// item en el reparto (contrato §12, mp-fe 1).
export function dv360OfferOf(item, groupMapping) {
    const payload = (item || {}).payload || {};
    const offer = payload.dv360_offer;
    if (!offer || !offer.name) return null;
    const keys = new Set(payload.group_keys || []);
    const platforms = (((groupMapping || {}).groups) || [])
        .filter((group) => keys.has(group.key))
        .flatMap((group) => group.platforms || [])
        .filter((p) => p && p.platform === DV360);
    const platform = offer.platform_raw || offer.label || (platforms[0] || {}).label || DV360;
    let amount = finite(offer.amount) ? Number(offer.amount) : null;
    if (amount === null && platforms.some((p) => finite(p.amount))) {
        amount = platforms.reduce((sum, p) => sum + (finite(p.amount) ? Number(p.amount) : 0), 0);
    }
    return {account: offer.name, adAccountId: offer.ad_account_id, platform, amount};
}
